import { IAnnotation } from '@ahryman40k/ts-fhir-types/lib/R4';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractDetailsComponent } from '../details/abstract-details/abstract-details.component';

@Component({
  selector: 'inc-alert-decourse-details',
  template: ''
})
export class AlertDecourseDetailsComponent<T> extends AbstractDetailsComponent<T> implements OnInit {
  @Input() user: any;
  @Input() commentUpdateId: number;
  @Input() postId: string;
  @Input() postIsOpened: boolean;
  @Output() callCommentSaveAndUpdate: EventEmitter<T> = new EventEmitter();
  @Output() callCommentMore: EventEmitter<{ component: T, index: number }> = new EventEmitter();
  @Output() callCancelComment: EventEmitter<null> = new EventEmitter();
  @Output() postIsOpenedOnChange: EventEmitter<{ state: boolean, id: string }> = new EventEmitter();

  iconNames = ['arrow-down', 'arrow-up'];
  iconName: string;

  constructor() { super(); }

  ngOnInit() { this.iconName = this.iconNames[this.postIsOpened ? 1 : 0]; }

  more(): void { this.callMore.emit(this.inData); }

  commentsSwitcher(): void {
    this.iconName = this.iconNames[this.iconName === this.iconNames[0] ? 1 : 0];
    this.postIsOpenedOnChange.emit({ state: !this.postIsOpened, id: this.postId });
  }

  onCallSaveComment(comment: IAnnotation): void { }

  onCallUpdateComment(comment: IAnnotation): void { }

  onCallCancelComment(): void { this.callCancelComment.emit(); }

  onCallCommentMore(comment: IAnnotation): void { }
}
